export default __webpack_public_path__ + "static/media/item-drop1.28f17e06.png";